function ContactMe() {
    return (
      <div>
        <p>Whats up?!</p>
      </div>
    );
  }
  
  export default ContactMe;